import { render, staticRenderFns } from "./InfPag.vue?vue&type=template&id=e7419ff8&lang=html&"
import script from "./InfPag.vue?vue&type=script&lang=js&"
export * from "./InfPag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports